import React from 'react';

/**
 * Review step body — shows the generated prompt read-only so the user can vet
 * the embedded field values before sending it to the agent.
 */
const ReviewPromptStep = ({ prompt }) => (
  <div className="reports-review-prompt-step">
    <p className="reports-review-prompt-hint">
      Review the generated prompt. Approve to run the report, or go back to edit
      your selections.
    </p>
    <pre className="reports-review-prompt">{prompt}</pre>
  </div>
);

export default ReviewPromptStep;
